<script>
    // Renedrer for ohlcbar + volume (optional)
    // It can be used as the main chart or an indicator

    import MMCandle from './primitives/mm_candle.js'
    import MMPrice from './primitives/mm_price.js'
    import { Overlay, layout_cnv } from '../../'

    export default {
        name: 'MM',
        mixins: [Overlay],
        methods: {
            meta_info() {
                return {
                    author: 'Mano', version: '1.0.0',
                    desc: 'Makers Move',
                    preset: {
                        name: 'Makers Move',
                        side: 'onchart',
                        settings: {
                            lineWidth: 1
                        }
                    }
                }
            },
            init() {
                this.price = new MMPrice(this)
            },
            draw(ctx) {

                //console.log("XCandle.draw() called. this.$props.data.length = " + this.$props.data.length)

                let full_candles = this.$props.layout.full_candles
                let layout = this.$props.layout
                if (full_candles[full_candles.length - 1]) {
                    let cmp = full_candles[full_candles.length - 1].raw[4]
                    for (let i = full_candles.length - 1; i >= 0; i--) {
                        let p2 = full_candles[i - 2]
                        let p1 = full_candles[i - 1]
                        let barData = full_candles[i]
                        if (p2) {
                            new MMCandle(this, ctx, layout, barData, p1, p2, cmp)
                        }
                    }
                }

                //if (this.price_line) this.price.draw(ctx)
            },
            use_for() { return ['MM'] },

            // When added as offchart overlay
            y_range() {
                return [
                    Math.max(...this.$props.sub.map(x => x[2])),
                    Math.min(...this.$props.sub.map(x => x[3]))
                ]
            }
        },

        // Define internal setting & constants here
        computed: {
            sett() {
                return this.$props.settings
            },
            show_volume() {
                return 'showVolume' in this.sett ?
                    this.sett.showVolume : true
            },
            price_line() {
                return 'priceLine' in this.sett ?
                    this.sett.priceLine : true
            },
            upVolBarColor() {
                return this.sett.upBarColor || "#23a77655"
            },
            downVolBarColor() {
                return this.sett.downBarColor || "#e5415055"
            },
            volBarWidth() {
                return this.sett.barWidth || 2
            },
            upBarColor() {
                return this.sett.upBarColor || "#23a776"
            },
            downBarColor() {
                return this.sett.downBarColor || "#e54150"
            },
            upBodyColor() {
                return this.sett.upBarColor || "#ECF8ED"
            },
            downBodyColor() {
                return this.sett.downBarColor || "#F8EEEC"
            },
            blackBarColor() {
                return this.sett.blackBarColor || "#FDFDFD"
            },
            barWidth() {
                return this.sett.barWidth || 1
            },
            hlcOnly() {
                return this.sett.hlcOnly || false
            },
            lineWidth() {
                return this.sett.lineWidth || 1
            }
        },
        data() {
            return { price: {} }
        }

    }
</script>
